import { Pagination, Typography } from "antd"
import { useTranslation } from "react-i18next"

import { itemRender } from "../../../../../../Components/Table"
import { pageSize } from "../../constants/allPageData"

const { Text } = Typography

// Pagination for the card view. The table gets all of this from Components/Table, which
// applies the same `itemRender` and the same "hide the pager when everything fits on one
// page" guard internally — a bare antd <Pagination> bypasses that, so the settings are
// gathered here instead of being spelled out at the call site.
//
// The shared `itemRender` swaps antd's prev/next arrows for text buttons. It is exported
// from Components/Table purely because there is no shared Pagination component; if one is
// ever added, this file collapses into it.
const DisputesPagination = ({ count, page, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className="custom-table">
      <Pagination
        rootClassName="ant-table-pagination ant-table-pagination-left"
        onChange={onChange}
        total={count || 0}
        pageSize={pageSize}
        current={page}
        showLessItems
        showTotal={(total, range) => (
          <Text>
            {t("Showing")}{" "}
            <Text strong>
              {t("_from_-_to_ of _total_", { from: range[0], to: range[1], total })}
            </Text>{" "}
            {t("results")}
          </Text>
        )}
        itemRender={(_, type, originalElement) =>
          pageSize >= count ? null : itemRender(_, type, originalElement, t)
        }
        showSizeChanger={false}
        showQuickJumper={false}
      />
    </div>
  )
}

export default DisputesPagination
